import React, { useState, useEffect } from "react";

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function getInitialValue(val) {
  if (val === null || val === undefined) return "";
  return val;
}

function setDeep(obj, path, newValue) {
  const root = Array.isArray(obj) ? [...obj] : { ...obj };
  let current = root;
  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i];
    current[key] = Array.isArray(current[key]) ? [...current[key]] : { ...current[key] };
    current = current[key];
  }
  current[path[path.length - 1]] = newValue;
  return root;
}

function AmazonProductListingEditableField({ field = {}, onFieldChange }) {
  var rawValue = get(field, "listing.value", null);
  var initial = getInitialValue(rawValue);

  var [value, setValue] = useState(initial);

  var isDropdown = get(field, "ui.input_type", "") === "dropdown";
  var options = get(field, "schema.allowed_values", []) || [];
  var isEditable = get(field, "schema.editable", true);

  var inputStyle = {
    width: "100%", 
    fontSize: 12, 
    padding: "4px 8px", 
    borderRadius: 6,
    border: isEditable ? "1px solid #ccc" : "1px solid red", 
    background: "var(--color-background-primary, #ffffff)", 
    color: isEditable ? "#333" : "#888", 
    cursor: isEditable ? "text" : "default" 
  };

  const handleStandardChange = (newVal) => {
    if (!isEditable) return;
    setValue(newVal);
    if (onFieldChange) onFieldChange({ field: field.field, value: newVal });
  };

  const handleDeepChange = (path, newVal) => {
    if (!isEditable) return;
    const updatedObject = setDeep(value, path, newVal);
    setValue(updatedObject);
    if (onFieldChange) onFieldChange({ field: field.field, value: updatedObject });
  };

  useEffect(() => {
    setValue(initial);
  }, [field]);

  if (isDropdown) {
    return (
      <select
        style={inputStyle}
        value={value !== null && typeof value !== "object" ? value : ""}
        onChange={(e) => handleStandardChange(e.target.value)}
        disabled={!isEditable}
      >
        <option value="">Select</option>
        {options.map((opt) => (
          <option key={String(opt)} value={String(opt)}>
            {String(opt)}
          </option>
        ))}
      </select>
    );
  }

  const renderDeep = (data, path = [], isObjProp = false) => {
    if (data === null || data === undefined) return null;

    if (typeof data !== "object") {
      return (
        <input
          type="text"
          style={{ ...inputStyle, width: isObjProp ? "60%" : "100%", marginBottom: 0 }}
          value={String(data)}
          onChange={(e) => handleDeepChange(path, e.target.value)}
          readOnly={!isEditable}
        />
      );
    }

    if (Array.isArray(data)) {
      return (
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          {data.map((item, index) => {
            const isPrimitive = typeof item !== "object" || item === null;
            return (
              <div 
                key={index} 
                style={{ 
                  marginBottom: isPrimitive ? "4px" : (index < data.length - 1 ? "8px" : "0")
                }}
              >
                {/* Lines and Item X labels completely removed */}
                {renderDeep(item, [...path, index])}
              </div>
            );
          })}
        </div>
      );
    }

    if (typeof data === "object") {
      return (
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          {Object.entries(data).map(([k, v]) => {
            const currentPath = [...path, k];
            
            if (typeof v !== "object" || v === null) {
              return (
                <div key={k} style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                  <span style={{ fontSize: "11px", fontWeight: "500", width: "35%", paddingRight: "5px", color: "#555", wordBreak: "break-word" }}>
                    {k}:
                  </span>
                  {renderDeep(v, currentPath, true)}
                </div>
              );
            }
            
            return (
              <div key={k} style={{ marginBottom: "6px", backgroundColor: "#fdfdfd", padding: "6px", borderRadius: "4px", border: "1px solid #ebebeb" }}>
                <div style={{ fontSize: "11px", fontWeight: "bold", color: "#333", marginBottom: "4px", textTransform: "capitalize" }}>
                  {k.replace(/_/g, " ")}
                </div>
                <div style={{ paddingLeft: "4px" }}>
                  {renderDeep(v, currentPath)}
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    return null;
  };

  if (value !== null && typeof value === "object") {
    return renderDeep(value);
  }

  return (
    <input
      type="text"
      style={inputStyle}
      value={value !== null && value !== undefined ? String(value) : ""}
      onChange={(e) => handleStandardChange(e.target.value)}
      readOnly={!isEditable}
    />
  );
}

export default AmazonProductListingEditableField;